import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IFullOfferCategory } from "@/data/model/OfferCategory";
import type { IOffer } from "@/data/model/Offer";
import { Format } from "@/data/util/Format";

import { translate } from "@/shared/localization/language";

import { i18n } from "@/portal/Trans";
import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";
import { TableFilter } from "@/portal/elements/TableFilter";
import { portalEvents } from "@/portal/events/portalEvents";
import { PortalFormat } from "@/portal/util/PortalFormat";

export class OfferCategoryTableController {
    private $element: JQuery;
    private dao: CatalogDao;
    private dataTable: DataTable<IFullOfferCategory>;
    private search: TableFilter;

    constructor(element: JQuery) {
        this.$element = element;

        this.dao = Factory.getInstance<CatalogDao>(CatalogDao);

        const tableConfig: IDataTableConfig<IFullOfferCategory> = {
            columnMapping: [
                {
                    name: i18n("general.fields.designation"),
                    property: "name",
                    styles: { width: "30%" },
                    formatter: (m) => {
                        return Format.htmlEscape(translate(m.name));
                    },
                },
                {
                    name: i18n("general.entities.offers"),
                    property: "offers",
                    styles: { width: "27%" },
                    formatter: (m, p) => {
                        return PortalFormat.toCommaSeparatedList<IOffer>(
                            p,
                            (c) => Format.htmlEscape(c.name)!,
                            (c) => "/offer/" + c.id,
                            4
                        );
                    },
                },
                {
                    name: i18n("general.fields.internalNote"),
                    property: "internalNote",
                    styles: { width: "27%" },
                },
                {
                    name: i18n("general.fields.available"),
                    property: "isAvailable",
                    styles: { width: "11%" },
                    formatter: (m, p) => (p ? i18n("general.yes") : i18n("general.no")),
                },
                {
                    name: "",
                    property: "id",
                    styles: { width: "110px", "text-align": "right" },
                    formatter: () => {
                        return $(
                            '<span><a class="btn btn-sm btn-clean btn-icon btn-icon-md"><i class="la la-edit"></i></a></span>'
                        );
                    },
                },
            ],
            filterProvider: {
                getFilter: () => this.search.getValue(),
                setFilter: (d) => this.search.setValue(d),
            },
            defaultSortAsc: true,
            locationDependend: true,
            defaultSortProperty: "name",
        };

        this.search = new TableFilter().appendTo(this.$element.find("> .kt-portlet__body.tablefilter"));
        this.dataTable = new DataTable<IFullOfferCategory>(
            this.$element.find("> .kt-portlet__body > .kt-datatable"),
            this.dao.offerCategoryDataSource,
            tableConfig
        );
        this.dataTable.onClick(
            (m) => {
                location.href = "/offercategory/" + m.id;
            },
            (m) => {
                window.open("/offercategory/" + m.id);
            }
        );

        this.dataTable.listenTo(this.search);
        portalEvents.OnLocationChanged.add(() => {
            this.dataTable.loadData(true);
        }, this);
    }
}
